export default __webpack_public_path__ + "static/media/investors-other.5694bba9.mp3";